module.exports = { "default": require("core-js/library/fn/reflect/own-keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/own-keys.js
// module id = 827
// module chunks = 36